import { Stack } from "@mui/material";
import { FieldComponentProps, TextField } from "@platform/design-system";

import { formatDate } from "../../../../utils";

import { FORM_FIELDS } from "./constants";
import { ProductCoverageMap } from "./types";
import { getParentField } from "./utils";

type Props = FieldComponentProps<"lastPayment"> & {
  productMap: ProductCoverageMap;
};

const LastPayment = ({
  field,
  methods,
  productMap,
}: Props): React.JSX.Element => {
  const prefix = getParentField(field.name, FORM_FIELDS.LAST_PAYMENT);
  const incumbentProductId: unknown = methods.watch(
    `${prefix}.${FORM_FIELDS.INCUMBENT_PRODUCT_ID}`,
  );
  const incumbentProduct =
    typeof incumbentProductId === "number"
      ? productMap.get(incumbentProductId)
      : undefined;

  return (
    <Stack spacing={3} data-testid="last-payment">
      <TextField
        size="md"
        label="Last Payment Amount"
        value={incumbentProduct?.lastPaymentAmount?.toFixed(2) ?? ""}
        startAdornment="$"
        fullWidth
        disabled
      />
      <TextField
        size="md"
        label="Last Payment Date"
        value={formatDate(incumbentProduct?.lastPaymentDate, true) ?? ""}
        fullWidth
        disabled
      />
    </Stack>
  );
};

export { LastPayment };
